import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  
  connect() {
    this.showTab(0)
  }
  
  change(event) {
    event.preventDefault()
    const button = event.currentTarget
    const tabIndex = this.tabTargets.indexOf(button)
    this.showTab(tabIndex)
  }
  
  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("bg-white", "text-blue-700", "border-blue-700", "border-b-white")
        tab.classList.remove("bg-gray-100", "text-gray-500")
      } else {
        tab.classList.add("bg-gray-100", "text-gray-500")
        tab.classList.remove("bg-white", "text-blue-700", "border-blue-700", "border-b-white")
      }
    })
    
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
